import { environment } from '../../environments/environment';

const API_AUTH_URL = environment.production
    ? 'https://identitytoolkit.googleapis.com/v1/accounts'
    : 'https://identitytoolkit.googleapis.com/v1/accounts';

const API_KEY = environment.production
    ? 'AIzaSyDkisBittUBkYRk_b-X4jFiRUTgnix04pU'
    : 'AIzaSyDkisBittUBkYRk_b-X4jFiRUTgnix04pU';

export class Constants {
    public static get apiKey(): string {
        return API_KEY;
    }

    public static get apiAuthUrl(): string {
        return API_AUTH_URL;
    }
}
